export const TOKEN_PAYMENT_STATUS = {
  PENDING_PAYMENT: 'pending_payment',
  PARTIALLY_PAID: 'partially_paid',
  PAID_UNVERIFIED: 'paid_unverified',
  PAID_VERIFIED: 'paid_verified',
  EXPIRED: 'expired',
  PARTIALLY_REFUNDED: 'partially_refunded',
  REFUNDED: 'refunded',
  CANCELLED: 'cancelled',
};

const TOKEN_PAYMENT_STATUSES = [
  { text: 'Pending Payment', value: TOKEN_PAYMENT_STATUS.PENDING_PAYMENT },
  { text: 'Partially Paid', value: TOKEN_PAYMENT_STATUS.PARTIALLY_PAID },
  { text: 'Paid Unverified', value: TOKEN_PAYMENT_STATUS.PAID_UNVERIFIED },
  { text: 'Paid Verified', value: TOKEN_PAYMENT_STATUS.PAID_VERIFIED },
  { text: 'Expired', value: TOKEN_PAYMENT_STATUS.EXPIRED },
  { text: 'Partially Refunded', value: TOKEN_PAYMENT_STATUS.PARTIALLY_REFUNDED },
  { text: 'Refunded', value: TOKEN_PAYMENT_STATUS.REFUNDED },
  { text: 'Cancelled', value: TOKEN_PAYMENT_STATUS.CANCELLED },
];

export const TOKEN_PAYMENT_STATUS_MAP = TOKEN_PAYMENT_STATUSES.reduce(
  (acc, val) => ({
    ...acc,
    [val.value]: val,
  }),
  {},
);

export default TOKEN_PAYMENT_STATUSES;



// WEBPACK FOOTER //
// ./src/constants/tokenPaymentStatuses.js